// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2BmuB","header":"ReportDetails_header__3H95p","title":"ReportDetails_title__OYQzj","left":"ReportDetails_left__3f7aM"};